import styled from "styled-components";

export const CiclosWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 40px;
  margin-bottom: 100px;
`;
